export default __webpack_public_path__ + "static/media/gov-qld-black-5.74c3a0a7.svg";